// src/app/highlight.directive.ts
import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import hljs from 'highlight.js';

@Directive({
  selector: '[appHighlight]',
})
export class HighlightDirective implements OnChanges {
  // Input property to receive the code string
  @Input('appHighlight') code!: string;
  // Optional input for the language (e.g., 'typescript', 'html')
  @Input() language: string;

  constructor(private readonly el: ElementRef) {}

  // We use OnChanges because the input code string might change dynamically
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['code']) {
      this.highlightCode();
    }
  }

  private highlightCode(): void {
    const element = this.el.nativeElement as HTMLElement;

    // 1. Clear previous content and set the new code
    element.textContent = this.code;

    // 2. Add the language class if specified (required by hljs themes)
    element.classList.add(`language-${this.language}`);

    // 3. Call the core highlight method
    hljs.highlightElement(element);
  }
}